import React, { useState, useEffect } from 'react'
import { Form, Modal, Checkbox, Input, Radio } from 'antd'

import { CopyOutlined } from '@ant-design/icons'
import { getCookie } from 'helper/cookie'
import lang from 'lang/en'
import { projectCopy } from 'api/Project/project'
import loadingIcons from 'icons/three-dots.svg'
import { useHistory } from 'react-router-dom'
import { copyTask, getResultCopyLastSubTask } from 'api/Project/sprintFlow'
import { Item } from 'gg-editor'

import { kpicheckgoal } from 'api/Project/kpifinance'

const initalState = {
  data: [],
  isLoading: false,
  check: 'Y',
}
let textTitleModal = ''
let textDesModal = ''

const ProjectCopy = (props) => {
  const {
    visibleModalCopy,
    setVisibleModalCopy,
    type,
    id_project,
    refreshPage,
    role,
    idEditPRJ,
  } = props
  const language = getCookie('lang')
  const word = lang[language]
  const [isLoading, setIsLoading] = useState(initalState.isLoading)
  const [check, setCheck] = useState(initalState.check)
  const [countCopy, setCountCopy] = useState(1)
  const token = getCookie('access_token_admin')
  const history = useHistory()
  const [showBtn, setShowBtn] = useState(true)
  if (type === 'project') {
    textTitleModal = word['project_copy_title']
    textDesModal = word['project_copy_des']
  } else if (type === 'subtask') {
    textTitleModal = word['subtask_copy_title']
    textDesModal = word['subtask_copy_des']
  }
  const [form] = Form.useForm()

  const [visibleModalKPI, setVisibleModalKPI] = useState(false)

  useEffect(() => {
    if (visibleModalCopy == true) {
      setShowBtn(true)
      form.setFieldsValue({
        numbercopy: 1,
      })
      setCountCopy(1)
    }
  }, [visibleModalCopy])

  const saveCopy = (type) => {
    setVisibleModalCopy(false)
    setVisibleModalKPI(false)

    const dataArray = {
      project_id_from: parseInt(idEditPRJ),
      project_id_to: parseInt(idEditPRJ),
      sprintflow_id: id_project,
      copy_num: parseInt(countCopy),
      delete_goal: type == 'kpi' ? 'Y' : 'N',
    }

    try {
      copyTask({
        params: dataArray,
        token: token,
      }).then((response) => {
        const { status, data, error } = response
        if (error) {
          setIsLoading(false)
          return true
        }
        if (status === 200) {
          refreshPage()
          setIsLoading(false)
          props.Setmode(true)
          props.setOneUnitFocus(1)
          props.swithCaseAddTaskFunction('')
          if (countCopy == 1) {
            props.setModalVisionAddTask(true)
          }
          // getResultCopyLastSubTask
          getResultCopyLastSubTask({
            level_id: parseInt(props.idTask),
            project_id: parseInt(idEditPRJ),
            token: token,
          })
            .then(async (response) => {
              const { status, data, error } = response
              if (error) {
                setIsLoading(false)
                return true
              }
              if (status === 200) {
                data.map((item, index) => {
                  if (index == 0) {
                    props.setIDSubtask(item.id)
                    props.setShowCode(item.code)
                    return false
                  }
                })
                setIsLoading(false)
              } else {
                setIsLoading(false)
                return true
              }
            })
            .catch((error) => {
              setIsLoading(false)
              console.error(error)
            })
        } else {
          setIsLoading(false)
          return true
        }
      })
    } catch (error) {
      console.log(error)
    }
  }

  const onOk = () => {
    if (type === 'project') {
      const data = {
        id: id_project,
        document: check,
      }
      try {
        setIsLoading(true)
        projectCopy({
          params: data,
          token: token,
        }).then((res) => {
          if (res.status === 200) {
            history.push({
              pathname: `/project/${res.data.project_id_to}/information`,
              state: { event_copy: true },
            })
            setIsLoading(false)
            window.location.reload()
          }
          setVisibleModalCopy(false)
        })
      } catch (error) {
        console.log(error)
      }
    } else if (type === 'subtask') {
      if (role == true) {
      } else {
        const data = {
          project_id: `${idEditPRJ}`,
          sprintflow_id: `${id_project}`,
          copy_num: parseInt(countCopy),
        }
        try {
          // setIsLoading(true)
          kpicheckgoal({
            params: data,
            token: token,
          }).then((res) => {
            if (res.status === 200) {
              // check overgoal */
              // if (res.data.overgoal == 'Y') {
              //   setVisibleModalCopy(false)
              //   setVisibleModalKPI(true)
              // } else {
              //   saveCopy('normal')
              // }
              saveCopy('normal')
              // setIsLoading(false)
            }
          })
        } catch (error) {
          console.log(error)
        }
      }
    }
  }
  const onChangeCheckBox = (value) => {
    if (!value.target.checked) {
      setCheck('N')
    } else {
      setCheck('Y')
    }
  }

  const onChangeNumofCopy = (value) => {
    console.log(value.target.value)
    setCountCopy(value.target.value)
    if (value.target.value < 1 || value.target.value > 20) {
      setShowBtn(false)
    } else {
      setShowBtn(true)
    }
  }
  const InputItem = () => {
    if (type === 'project') {
      return (
        <Checkbox
          id="checkboxCopy"
          className="checkbox"
          onChange={onChangeCheckBox}
          value={check}
          defaultChecked={check}
        >
          Copy Document
        </Checkbox>
      )
    } else if (type == 'subtask') {
      return (
        <div style={{ width: '100%' }}>
          <h4
            style={{ display: 'flex', justifyContent: 'flex-start', marginBottom: '8px' }}
          >
            Number of copies
          </h4>
          <Form form={form} name="initsubtask">
            <Form.Item
              name="numbercopy"
              rules={[
                {
                  whitespace: true,
                  required: true,
                  message: 'Please enter number of copies',
                },
              ]}
            >
              <Input
                id="Number of copies"
                type="number"
                className="border"
                placeholder="Number of copies"
                min={1}
                onChange={onChangeNumofCopy}
                defaultValue={1}
                size="large"
                style={{ width: '100%' }}
              ></Input>
            </Form.Item>
          </Form>
        </div>
      )
    }
  }

  return (
    <div>
      <Modal
        maskClosable={false}
        className="ModalStatusOption"
        visible={visibleModalCopy}
        okText={'Confirm'}
        onOk={() => onOk()}
        onCancel={() => setVisibleModalCopy(false)}
        okButtonProps={{ disabled: !showBtn }}
      >
        <CopyOutlined className="CopyOutlined" />
        <h2>{textTitleModal}</h2>
        <h4>{textDesModal}</h4>
        {InputItem()}
        <div className={isLoading ? 'loading-copy-project' : 'active-waite'}>
          <img src={loadingIcons}></img>
        </div>
        <div className={isLoading ? 'block-event' : 'active-waite'}></div>
      </Modal>

      <Modal
        maskClosable={false}
        className="ModalStatusOption"
        visible={visibleModalKPI}
        okText={'Ok'}
        onOk={() => saveCopy('kpi')}
        onCancel={() => setVisibleModalKPI(false)}
        cancelButtonProps={{ id: 'btnCancel' }}
      >
        <CopyOutlined className="CopyOutlined" />
        <div style={{ margin: '32px 0px 32px 0px' }}>
          <h2>KPI/Finance subtask goals is negative.</h2>
          <h4>Do you want to remove subtask goals ?</h4>
        </div>
      </Modal>
    </div>
  )
}
export default ProjectCopy
